import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Brand Master', screenId: '4.3.5', module: 'Procurement', apiPath: 'brand', screenName: 'BrandMaster', idField: 'BrandId', nameField: 'BrandName',
  gridColumns: [{ field: 'BrandId', header: 'Brand ID' }, { field: 'BrandName', header: 'Brand Name' }],
  formFields: [{ field: 'BrandId', label: 'Brand Id', disabled: true }, { field: 'BrandName', label: 'Brand Name', required: true }]
});
